import React, { useContext, useState } from 'react'
import AreYouSureModal from '../../Modals/AreYouSureModal';
import { deleteUserAsAdminApi } from '../../Constants';
import { Context } from '../../Context/Context';
import { signOut } from 'aws-amplify/auth';
import { toast } from 'react-toastify';


function DeleteAccount() {
    const [uploadNew, setUploadNew] = useState(false); 
    const {userDetails, makeApiCallFunc} = useContext(Context);

    const [deleting, setDeleting] = useState(false);
    // The server deletes the login (Cognito) and all the account's data in one
    // go. Then we only sign out here - the old code also tried to delete the
    // login again from the browser, which always failed (it was already gone)
    // and left the page stuck.
    const deleteAcc = () =>
    {
      if (deleting) return;
      setDeleting(true);
      makeApiCallFunc(deleteUserAsAdminApi,
        {
          username: userDetails?.email,
          id: userDetails?._id
        },
        async () => {
          // the login no longer exists, so signing out can't reach Cognito -
          // it still clears this browser's session, which is all we need
          try { await signOut(); } catch (error) { console.log(error); }
          toast.success('Your account has been deleted.');
          // full reload so nothing of the old account stays in memory
          setTimeout(() => window.location.assign('/'), 1200);
        },
        (error) => {
          console.log(error);
          setDeleting(false);
          toast.error(error?.response?.data?.message || 'Could not delete your account. Please try again.');
        },
        null,
        true
      );
    }
    return (
      <>
        {
          uploadNew &&
          <AreYouSureModal
          onClose={()=>setUploadNew(false)}
          onSubmit={deleteAcc}
          uploadNew={uploadNew}
          busy={deleting}
          busyLabel="Deleting…"
          buttonName="Yes, delete it"
          text="This action cannot be reversed — your account and all your cases will be permanently deleted."
          />
        }
        <div className='w-full font-plexsans' style={{maxWidth:'440px'}}>
          <h2 style={{margin:'0 0 4px', font:"400 22px/1.25 'Spectral',serif", color:'#14213d'}}>Delete account</h2>
          <p style={{margin:'0 0 22px', font:"400 13.5px/1.5 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)'}}>This permanently removes your account and every case you've created — including any in progress with attorneys. This cannot be undone.</p>
          <button
            className="cursor-pointer rounded-sm"
            style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#9a3b2e', border:'none', padding:'12px 22px'}}
            onClick = {()=>setUploadNew(true)}>Delete my account</button>
        </div>
        </>
      )
}

export default DeleteAccount;
